import { render, staticRenderFns } from "./ProductNew.vue?vue&type=template&id=028d7f28"
import script from "./ProductNew.vue?vue&type=script&lang=js"
export * from "./ProductNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports